import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// Login principal = vitrine de produtos Boneside (Split layout).
// O login centralizado clássico segue em pages/auth/Login.tsx, preservado p/ um
// possível login interno (separação por hostname portal.* vs rocky.*).
const LoginPage = Loadable(lazy(() => import('pages/auth/LoginVitrine')));
const AuthCallback = Loadable(lazy(() => import('pages/auth/AuthCallback')));
const EsqueciSenhaPage = Loadable(lazy(() => import('pages/auth/EsqueciSenhaPage')));
const DefinirSenhaPage = Loadable(lazy(() => import('pages/auth/DefinirSenhaPage')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      element: <LoginPage />
    },
    {
      path: 'auth/callback',
      element: <AuthCallback />
    },
    // Definição/recuperação de senha — públicas (usuário sem sessão).
    {
      path: 'esqueci-senha',
      element: <EsqueciSenhaPage />
    },
    {
      path: 'definir-senha',
      element: <DefinirSenhaPage />
    },
    {
      path: 'redefinir-senha',
      element: <DefinirSenhaPage />
    }
  ]
};

export default LoginRoutes;
